module.exports = __webpack_public_path__ + "img/internet.8dde32ba.png";